<template>
  <el-card shadow="hover">
    <div class="head-tit">装卸费-查看详情</div>
    <el-table
      :data="handlingGoodsdetaiList"
      style="width: 100%"
      border>
      <el-table-column
        type="index"
        label="序号"
        fixed
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="goodsCode"
        label="商品编码"
        align="center">
      </el-table-column>
      <el-table-column
        prop="goodsName"
        label="商品名称"
        align="center">
      </el-table-column>
      <el-table-column
        prop="standard"
        align="center"
        label="规格">
      </el-table-column>
      <el-table-column
        prop="box"
        label="箱规(件/箱)"
        align="center">
      </el-table-column>
      <el-table-column
        prop="computeTypeName"
        align="center"
        label="计费方式">
      </el-table-column>
      <el-table-column
        prop="calculationName"
        label="计费单位"
        align="center">
      </el-table-column>
      <el-table-column
        prop="countNum"
        align="center"
        label="计算数量">
      <template slot-scope="scope">
        {{scope.row.countNum | tofixed}}
      </template>
      </el-table-column>
      <el-table-column
        prop="price"
        align="center"
        label="单价(元)">
      <template slot-scope="scope">
        <label>{{scope.row.price ? parseFloat(scope.row.price).toFixed(2) : '0.00'}}</label>
      </template>
      </el-table-column>
      <el-table-column
        prop="money"
        align="center"
        label="单项费用(元)">
      <template slot-scope="scope">
        <label v-if="scope.row.isAcc == 1">-</label>
        <label v-else>{{scope.row.money | tofixed2}}</label>
      </template>
      </el-table-column>
    </el-table>
    <div class="btm-context">费用合计：{{this.money}}元</div>
  </el-card>
</template>

<script>
import costMenu from '../../store/costMenu/index.js'
import { GETCOSTDETAIL } from '../../store/costMenu/types.js'
import { mixin } from './components/mixins'
export default {
  name: 'handlinggoodsdetail',
  data () {
    return {
      code: '', // 商品编码
      money: 0 // 总费用
    }
  },
  components: {
  },
  computed: {
    // 获取装卸费详情列表
    handlingGoodsdetaiList () {
      return costMenu.state.handlingGoodsdetaiList
    }
  },
  watch: {
    // 重新请求数据
    $route (to, from) {
      if (this.$route.params.code) {
        this.code = this.$route.params.code
        this.money = this.$route.params.money
        this.getList()
      }
    },
    handlingGoodsdetaiList: {
      deep: true,
      handler (val) {
        // if (val.length) {
        //   let sum = 0
        //   val.forEach((item) => {
        //     sum += item.money
        //   })
        //   this.num = sum
        // }
      }
    }
  },
  mounted () {
    this.code = this.$route.params.code
    this.money = this.$route.params.money
    // 获取列表数据
    this.getList()
  },
  methods: {
    // 获取列表数据
    getList () {
      let params = {
        costType: 'COST_PRO_MOVE',
        code: this.code
      }
      this.$store.dispatch(GETCOSTDETAIL, params)
    }
  },
  mixins: [ mixin ]
}
</script>

<style scoped>
  .head-tit {
    font-size: 18px;
    font-weight: bold;
    padding-bottom: 20px;
  }
  .btm-context {
    padding: 15px 0;
    padding-right: 0px;
    color: #808080;
    font-size: 16px;
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/page/costMenu/HandlingGoodsDetail.vue